'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deprecationWarning = require('./deprecationWarning');

var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * playables can be an array
 */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule VideoDataPropTypeDeclaration
 */

exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  contentTeam: _propTypes2.default.string,
  description: _propTypes2.default.string,
  duration: function duration(props) {
    if (props.duration !== undefined) {
      (0, _deprecationWarning2.default)('DEPRECATION WARNING:\n' + 'VideoProvider.props.duration is deprecated in favor of "durationMs" ' + 'and will be removed in v3.0.0.');
    }
  },

  durationMs: _propTypes2.default.number,
  endTimeMs: _propTypes2.default.number,
  startTimeMs: _propTypes2.default.number,
  src: _propTypes2.default.string,
  sport: _propTypes2.default.string,
  title: _propTypes2.default.string,
  userRole: _propTypes2.default.string,
  videoId: _propTypes2.default.string
}));
module.exports = exports['default'];